module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN7.6a2d9827.png";